import { useQuery } from "@tanstack/react-query";
import {
  workflowsService,
  Workflow,
  WorkflowCaseStatus,
  CaseStatusWithUsage,
  StatusWorkflowMapping,
} from "../../services/workflows.service";

/**
 * Fetch all workflows (read-only admin view)
 */
export function useWorkflowsAdmin() {
  return useQuery<Workflow[]>({
    queryKey: ["admin", "workflows"],
    queryFn: workflowsService.getAll,
    staleTime: 1000 * 60 * 60, // 1 hour - workflows don't change often
  });
}

/**
 * Fetch all case statuses with workflow usage counts (read-only admin view)
 */
export function useCaseStatusesAdmin() {
  return useQuery<CaseStatusWithUsage[]>({
    queryKey: ["admin", "case-statuses"],
    queryFn: workflowsService.getCaseStatuses,
    staleTime: 1000 * 60 * 60, // 1 hour - statuses don't change often
  });
}

/**
 * Fetch statuses for a specific workflow (read-only admin view)
 */
export function useWorkflowStatusesAdmin(workflowId: string | undefined) {
  return useQuery<WorkflowCaseStatus[]>({
    queryKey: ["admin", "workflow-statuses", workflowId],
    queryFn: () => workflowsService.getWorkflowStatuses(workflowId!),
    enabled: !!workflowId,
    staleTime: 1000 * 60 * 60, // 1 hour - statuses don't change often
  });
}

/**
 * Fetch workflows that use a specific case status (read-only admin view)
 */
export function useWorkflowsForCaseStatus(caseStatusId: string | undefined) {
  return useQuery<StatusWorkflowMapping[]>({
    queryKey: ["admin", "case-status-workflows", caseStatusId],
    queryFn: () => workflowsService.getWorkflowsForCaseStatus(caseStatusId!),
    enabled: !!caseStatusId,
    staleTime: 1000 * 60 * 60, // 1 hour - mappings don't change often
  });
}
